import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// guards
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
// import RoleBasedGuard from '../guards/RoleBasedGuard';
// config
import { PATH_AFTER_LOGIN } from '../config';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen loadable={true} />}>
      <Component {...props} />
    </Suspense>
  );

export default function Router() {
  return useRoutes([
    {
      path: 'auth',
      element: <DashboardLayout />,
      children: [
        // {
        //   path: 'login',
        //   element: (
        //     <GuestGuard>
        //       <Login />
        //     </GuestGuard>
        //   ),
        // },
        // {
        //   path: 'register',
        //   element: (
        //     <GuestGuard>
        //       <Register />
        //     </GuestGuard>
        //   ),
        // },
        { path: 'login', element: <Login /> },
        { path: 'change-password', element: <ChangePassword /> },
        { path: 'forgot-password', element: <ForgotPassword /> },
        { path: 'reset-password', element: <ResetPassword /> },
        { path: 'new-password', element: <NewPassword /> },
        { path: 'verify', element: <VerifyCode /> },
      ],
    },

    // Home Routes
    {
      path: '/',
      element: (
        // <AuthGuard>
        <DashboardLayout />
        // </AuthGuard>
      ),
      children: [
        // { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { index: true, element: <Home /> },
        {
          path: 'register', // Matches /register
          element: <Register />,
        },
        // { path: 'games/:categSlug', element: <GamesByCateg /> },
        { path: 'games/:categSlug/:companyId', element: <GamesByCateg /> },
        // { path: 'games/:companyId', element: <GamesByCateg /> },
        { path: 'leaderboard', element: <Leaderboard /> },
      ],
    },

    // History Routes
    {
      path: 'history',
      element: (
        // <AuthGuard>
        <GuestGuard>
          <DashboardLayout />
        </GuestGuard>
        // </AuthGuard>
      ),
      children: [
        { index: true, element: <History /> },
        // { path: '/history/bet', element: <GameHistory /> },
        // { path: '/history/transaction', element: <TransactionHistory /> },
      ],
    },

    {
      path: '/arrangement',
      element: <DashboardLayout />,
      children: [
        { index: true, element: <Arrangement /> },
        { path: ':category', element: <Arrangement /> },
      ],
    },

    // User Routes>
    {
      path: 'user',
      element: (
        // <AuthGuard>
        <GuestGuard>
          <DashboardLayout />
        </GuestGuard>
        // </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: '/user/account', element: <AccountProfile /> },
        { path: '/user/banks', element: <MemberBankList /> },
        { path: '/user/wallet', element: <Wallet /> },
      ],
    },

    // Referral Route
    {
      path: '/',
      element: (
        <GuestGuard>
          <DashboardLayout />
        </GuestGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: '/referral', element: <Referral /> },
        // { path: '/referral/:tab', element: <Referral /> },
      ],
    },

    // Bonus Route
    {
      path: '/',
      element: (
        // <AuthGuard>
        <DashboardLayout />
        // </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: '/vip', element: <Vip /> },
        { path: '/agent', element: <Agent /> },
      ],
    },

    // Invite Routes
    {
      path: '/',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'invite', element: <Invite /> },
      ],
    },

    // Promotion Routes
    {
      path: '/',
      element: (
        // <AuthGuard>
        <DashboardLayout />
        // </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'promotion/tab', element: <Promotion /> },
        { path: 'promotion/view/:promotionId', element: <ViewPromotion /> },
        { path: 'promotion/spin', element: <SpinTheWheel /> },
      ],
    },

    {
      path: 'payStatus',
      element: <LogoOnlyLayout />,
      children: [
        {
          path: ':paymentMethod',
          element: <PaymentStatus />,
          index: true,
        },
      ],
    },

    // AngPau
    // {
    //   path: '/angpau',
    //   element: (
    //     <DashboardLayout>
    //       <AngPau />
    //     </DashboardLayout>
    //   ),
    // },

    // Main Routes
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoon /> },
        { path: 'maintenance', element: <Maintenance /> },
        { path: '918Kiss.apk', element: <TriggerDownload /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },

    // CustomPage Route
    {
      path: '/page',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: ':customPage', element: <CustomPage /> },
      ],
    },
    {
      path: '/forgot-password-new',
      element: <ForgotPasswordNew />,
    },

    // {
    //   path: '/',
    //   element: <MainLayout />,
    //   children: [
    //     { element: <HomePage />, index: true },
    //     { path: 'about-us', element: <About /> },
    //     { path: 'contact-us', element: <Contact /> },
    //     { path: 'faqs', element: <Faqs /> },
    //   ],
    // },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

// AUTHENTICATION
// const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const Login = Loadable(lazy(() => import('../layouts/dashboard/header/visitor/LoginPage')));
const Register = Loadable(lazy(() => import('../layouts/dashboard/header/visitor/RegisterPage')));
const ResetPassword = Loadable(lazy(() => import('../layouts/dashboard/header/forgotpassword/ResetPasswordDialog')));
const NewPassword = Loadable(lazy(() => import('../pages/auth/NewPassword')));
const VerifyCode = Loadable(lazy(() => import('../pages/auth/VerifyCode')));
const ChangePassword = Loadable(lazy(() => import('../pages/auth/ChangePassword')));
const ForgotPassword = Loadable(lazy(() => import('../pages/auth/ForgotPassword')));
const ForgotPasswordNew = Loadable(lazy(() => import('../layouts/dashboard/header/visitor/ForgotPasswordForm')));

// HOME
const Home = Loadable(lazy(() => import('../views/game/Home')));

// HOME
const Arrangement = Loadable(lazy(() => import('../views/arrangement/Arrangement')));

// LEADERBOARD
const Leaderboard = Loadable(lazy(() => import('../views/game/Leaderboard')));

// GAMES
const GamesByCateg = Loadable(lazy(() => import('../views/game/GamesByCateg')));

// HISTORY
const History = Loadable(lazy(() => import('../views/history/History')));

// GAME HISTORY
const GameHistory = Loadable(lazy(() => import('../views/history/GameHistory')));

// TRANSACTION HISTORY
const TransactionHistory = Loadable(lazy(() => import('../views/history/TransactionHistory')));

// USER
const AccountProfile = Loadable(lazy(() => import('../views/user/AccountProfile')));
const MemberBankList = Loadable(lazy(() => import('../views/user/MemberBankList')));
const Wallet = Loadable(lazy(() => import('../views/user/Wallet')));

// INVITE
const Invite = Loadable(lazy(() => import('../views/share/Invite')));

// PROMOTION
const Promotion = Loadable(lazy(() => import('../views/promotion/Promotion')));
const ViewPromotion = Loadable(lazy(() => import('../views/promotion/ViewPromotion')));
const SpinTheWheel = Loadable(lazy(() => import('../views/promotion/SpinTheWheel')));
const AngPau = Loadable(lazy(() => import('../views/promotion/AngPau')));

// PAYMENT STATS
const PaymentStatus = Loadable(lazy(() => import('../pages/PaymentStatus')));

// REFERRAL
const Referral = Loadable(lazy(() => import('../views/referral/Referral')));

// Bonus
const Vip = Loadable(lazy(() => import('../views/referral/Vip')));
const Agent = Loadable(lazy(() => import('../views/referral/Agent')));

// TRIGGER APK DOWNLOAD
const TriggerDownload = Loadable(lazy(() => import('../views/game/TriggerDownload')));

// MAIN
const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const Page403 = Loadable(lazy(() => import('../pages/Page403')));
const Page404 = Loadable(lazy(() => import('../pages/Page404')));

// CUSTOM PAGE
const CustomPage = Loadable(lazy(() => import('../views/CustomPage')));
